import displayAdSlot from './src/components/ad-slot';

export default displayAdSlot;
